export default {
  metadata: {
    version: '1.0.0',
    id: 'dropdown-menu-group-1.0.0',
    name: 'JDSDropdownMenuGroup'
  },
  hierarchy: {
    container: [
      'top-jds_divider',
      {
        'label-container': ['label-jds-text']
      },
      {
        'menu-item-container': ['menu-item-slot']
      },
      'bottom-jds_divider'
    ]
  },
  base: {
    'top-jds_divider': {
      hidden: false,
      orientation: 'horizontal',
      pad: 'xtra-small',
      padPosition: 'top'
    },
    'bottom-jds_divider': {
      hidden: false,
      orientation: 'horizontal',
      pad: 'none',
      padPosition: 'all'
    },
    'label-container': {
      width: '{d_6}',
      'padding-top': '{d_3}',
      'padding-right': '{d_5}',
      'padding-left': '{d_4}'
    },
    container: {
      hidden: false,
      width: '{d_0}',
      'background-color': '{d_7}',
      'flex-direction': '{d_1}'
    },
    'menu-item-container': {
      width: '{d_8}',
      'flex-direction': '{d_2}'
    },
    'menu-item-slot': {
      hidden: false
    },
    'label-jds-text': {
      'font-family': '{text_172}',
      color: '{text_20}',
      'font-size': '{text_171}',
      'line-height': '{text_173}',
      'letter-spacing': '{text_174}',
      'font-weight': '{text_175}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}',
      hidden: false
    }
  },
  variant: {
    _hideTopDivider: {
      true: {
        'top-jds_divider': {
          hidden: true
        },
        'label-container': {
          hidden: true
        }
      }
    },
    hideBottomDivider: {
      true: {
        'bottom-jds_divider': {
          hidden: true
        }
      }
    }
  },
  api: {
    children: {
      'menu-item-slot': {
        name: 'children',
        accepts: ['jds_dropdown_menu_item']
      }
    },
    data: {
      'label-jds-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      }
    },
    config: {
      hideBottomDivider: {
        values: [false, true]
      },
      _hideTopDivider: {
        values: [false, true]
      }
    }
  }
};
